module.exports = __webpack_public_path__ + "static/media/circle-loader-64px.ba28bea3.gif";